import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'
import { CommentsCommentFragment } from 'generated/resources/graphql'

import { ReactionsReactionValues } from 'modules/core/components/Reactions/Reaction'

import Comment from 'modules/comments/components/CommentsContainer/Comment'

interface Props {
  comments: CommentsCommentFragment[]
  onAddReaction?: (
    variables: ReactionsReactionValues,
    parentResourceId: string
  ) => Promise<{ id: string } | undefined>
  onDeleteReaction?: (
    id: string,
    parentResourceId: string,
    resourceId: string,
    textCode: string
  ) => Promise<{ success: boolean } | undefined>
}

const FullListWithScroll = ({ comments, onAddReaction, onDeleteReaction }: Props) => {
  return (
    <AnimatePresence initial={false}>
      {comments.length > 0 && (
        <Box gap="s24" paddingBottom="s24">
          {comments.map((comment) => (
            <Comment
              key={comment.id}
              comment={comment}
              onAddReaction={onAddReaction}
              onDeleteReaction={onDeleteReaction}
            />
          ))}
        </Box>
      )}
    </AnimatePresence>
  )
}

export default FullListWithScroll
